import React, {Component} from 'react';
import {reverseShortDate, fullDateShow} from '../../../../common/constants/datesFormat';
import moment from 'moment';

class DispatchOrderExportFormat extends Component {
  render() {
    const {tableId, values} = this.props;
    return (
      <table id={tableId} hidden>
        <tbody>
          <tr style={{'height': '40px'}}>
            <td colSpan='2' style={{'fontWeight': 'bolder', 'fontSize': '12pt', 'verticalAlign': 'middle'}}>
              TOYOTA DEL ECUADOR S.A.</td>
            <td colSpan='12' style={{'fontWeight': 'bold', 'fontSize': '14pt',
              'textAlign': 'center', 'verticalAlign': 'middle'}}>
              VEHÍCULOS A FACTURAR</td>
            <td style={{'textAlign': 'right'}}>Página:</td>
            <td>1</td>
          </tr>
          <tr>
            <td colSpan='2'>VEHICULOS</td>
            <td colSpan='12'></td>
            <td style={{'textAlign': 'right'}}>Fecha:</td>
            <td>{moment(Date.now()).format(fullDateShow)}</td>
          </tr>
          <tr>
            <td>FECHA:</td>
            <td>{moment(values.addDate).format(reverseShortDate)}</td>
            <td>Nº ORDEN:</td>
            <td colSpan='2'>{String(values.orderId)}</td>
            <td>FACTURAR A:</td>
            <td colSpan='2'>{`'${values.dealerId}`}</td>
            <td colSpan='3'>{values.vehiclesArray[0] ? values.vehiclesArray[0].invoiceTo : ''}</td>
            <td colSpan='4'></td>
            <td>{values.addUser}</td>
          </tr>
          <tr><td colSpan='16'></td></tr>
          <tr>
            <td>OBSERVACION:</td>
            <td colSpan='4'></td>
            <td>TIPO:</td>
            <td colSpan='3'>{values.typeDescription}</td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td style={{'backgroundColor': '#99CCFF'}}>CHASIS</td>
            <td style={{'backgroundColor': '#99CCFF'}}>VEHICULO</td>
            <td style={{'backgroundColor': '#99CCFF'}}>KATASHIKI</td>
            <td style={{'backgroundColor': '#99CCFF'}}>SFX</td>
            <td style={{'backgroundColor': '#99CCFF'}}>COLOR</td>
            <td style={{'backgroundColor': '#99CCFF'}}>UBICACION</td>
            <td style={{'backgroundColor': '#99CCFF'}}>PEDIDO</td>
            <td style={{'backgroundColor': '#99CCFF'}}>FECHA LIQUIDACIÓN</td>
            <td style={{'backgroundColor': '#99CCFF'}}>CONCESIONARIO ENTREGA</td>
            <td style={{'backgroundColor': '#99CCFF'}}>AGENCIA ENTREGA</td>
            <td style={{'backgroundColor': '#99CCFF'}}>ES</td>
            <td style={{'backgroundColor': '#99CCFF'}}>FECHA SOL</td>
            <td style={{'backgroundColor': '#99CCFF'}}>NUEVA FECHA ENTREGA</td>
            <td style={{'backgroundColor': '#99CCFF'}}>FACTURAR A</td>
            <td style={{'backgroundColor': '#99CCFF'}}>IMPORTADOR</td>
            <td style={{'backgroundColor': '#99CCFF'}}>ACCESORIOS</td>
            <td style={{'backgroundColor': '#99CCFF'}}>COMBOS ASIGNADOS</td>
          </tr>
          {values.vehiclesArray.map((veh) => {
            return <tr key={values.vehiclesArray.indexOf(veh)}>
              <td>{veh.chassis}</td>
              <td>{veh.model}</td>
              <td>{veh.katashiki}</td>
              <td>{veh.sfx}</td>
              <td>{veh.color}</td>
              <td>{veh.location}</td>
              <td>{veh.vehOrder}</td>
              <td>{veh.dateLiquidaton}</td>
              <td>{veh.destinyDealer}</td>
              <td>{veh.agency}</td>
              <td>?</td>
              <td>{veh.dateSolPdi}</td>
              <td>{veh.dateSolPdiNew}</td>
              <td>{veh.invoiceTo}</td>
              <td>{veh.importer}</td>
              <td>{String(veh.detailCombo)}</td>
              <td>{veh.combo}</td>
            </tr>;
          })}
        </tbody>
      </table>
    );
  }
}

export default DispatchOrderExportFormat;
